import { pdfComponents } from '../components/pdfComponents';
import { pdfEngine } from '../pdfEngine';

export const quantitySheetTemplate = {
  generate: (project, record, auditLog) => {
    const meta = project.metadata || {};
    const data = record.data || {};
    const items = data.items || [];
    const docId = `CN-QS-${record.rootId.split('-')[1]}`;
    const hash = auditLog ? auditLog.hash : 'PENDING_HASH';

    const tableBody = [
      // سطر هدر
      [
        { text: 'ردیف', style: 'tableHeader' },
        { text: 'شرح عملیات اجرایی', style: 'tableHeader' },
        { text: 'طول (m)', style: 'tableHeader' },
        { text: 'عرض (m)', style: 'tableHeader' },
        { text: 'ارتفاع (m)', style: 'tableHeader' },
        { text: 'تعداد', style: 'tableHeader' },
        { text: 'حجم (m³)', style: 'tableHeader' }
      ]
    ];

    // سطرهای داده
    items.forEach((item, index) => {
      const vol = (item.length || 0) * (item.width || 0) * (item.height || 0) * (item.count || 1);
      tableBody.push([
        { text: (index + 1).toString(), alignment: 'center' },
        { text: item.desc || '---' },
        { text: item.length?.toString() || '0', alignment: 'center' },
        { text: item.width?.toString() || '0', alignment: 'center' },
        { text: item.height?.toString() || '0', alignment: 'center' },
        { text: item.count?.toString() || '1', alignment: 'center' },
        { text: vol.toFixed(2), alignment: 'center', bold: true }
      ]);
    });

    // سطر جمع کل
    tableBody.push([
      { text: 'مجموع احجام عملیاتی', colSpan: 6, alignment: 'right', bold: true },
      {}, {}, {}, {}, {},
      { text: (data.totalVolume || 0).toFixed(2), alignment: 'center', bold: true, fillColor: '#e2e8f0' }
    ]);

    const documentDefinition = {
      info: {
        title: `صورت‌جلسه احجام - ${docId}`,
        author: 'Civil Nexus Platform',
        creator: 'Civil Nexus'
      },
      content: [
        pdfComponents.buildHeader('صورت‌جلسه احجام عملیات اجرایی', meta, docId, record.revision),
        pdfComponents.buildProjectMeta(meta),
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: tableBody
          },
          layout: 'lightHorizontalLines'
        },
        pdfComponents.buildSignatures(),
        pdfComponents.buildAuditFooter(hash, docId)
      ]
    };

    pdfEngine.download(documentDefinition, `CivilNexus_${docId}_Rev${record.revision}.pdf`);
  }
};
